import { render, staticRenderFns } from "./balance.vue?vue&type=template&id=6af3cf66&scoped=true"
import script from "./balance.vue?vue&type=script&lang=js"
export * from "./balance.vue?vue&type=script&lang=js"
import style0 from "./balance.vue?vue&type=style&index=0&id=6af3cf66&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af3cf66",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6af3cf66')) {
      api.createRecord('6af3cf66', component.options)
    } else {
      api.reload('6af3cf66', component.options)
    }
    module.hot.accept("./balance.vue?vue&type=template&id=6af3cf66&scoped=true", function () {
      api.rerender('6af3cf66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/data/balance.vue"
export default component.exports